import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase/app';
import 'firebase/auth';

import Home from './views/Home.vue'
import Navigation from './components/navigation.vue'
import Welcome from './components/Welcome.vue'
import Search from './components/mentorSearch.vue'
import UserProfile from './components/userProfile.vue'
import Relationships from './components/relationships.vue'
import RelationshipAdmin from './components/relationshipAdmin.vue'
import Login from './components/Login.vue'
import Verify from './components/verification.vue'
import NotAuthorised from './components/NotAuthorised.vue'
import ConfigAdmin from './components/ConfigAdmin.vue'
import AdminEmail from './components/authAdmin.vue'
import MentorAdmin from './components/mentorAdmin.vue'
import ClientAdmin from './components/clientAdmin.vue'
import MentorReport from './components/mentorReport.vue'
import WelcomeAdmin from './components/welcomeAdmin.vue'
import PrivacyAdmin from './components/privacyAdmin.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'root',
      component: Login
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/verify',
      name: 'verify',
      component: Verify
    },
    {
      path: '/home',
      name: 'home',
      component: Navigation,
      meta: {
         requiresAuth: true
      },
      children: [
        {
          path: '',
          component: Welcome
        },
        {
          path: 'welcome',
          name: 'welcome',
          component: Welcome,
          meta: {
             requiresAuth: true
          }
        },
        {
          path: 'search',
          name: 'search',
          component: Search,
          meta: {
             requiresAuth: true
          }
        },
        {
          path: 'userprofile',
          name: 'userProfile',
          component: UserProfile,
          meta: {
             requiresAuth: true
          }
        },
        {
          path: 'relationships',
          name: 'relationships',
          component: Relationships,
          meta: {
             requiresAuth: true
          }
        },
        {
          path: 'mentors',
          name: 'mentoradmin',
          component: MentorAdmin,
          meta: {
             requiresAuth: true
          }
        },
        {
          path: 'clients',
          name: 'clientadmin',
          component: ClientAdmin,
          meta: {
             requiresAuth: true
          }
        },
        {
          path: 'reladmin',
          name: 'reladmin',
          component: RelationshipAdmin,
          meta: {
             requiresAuth: true
          }
        },
        {
          path: 'mentorreport',
          name: 'mentorreport',
          component: MentorReport,
          meta: {
             requiresAuth: true
          }
        },
        {
          path: 'config',
          name: 'configadmin',
          component: ConfigAdmin,
          meta: {
             requiresAuth: true
          }
        },
        {
          path: 'adminemail',
          name: 'adminemail',
          component: AdminEmail,
          meta: {
             requiresAuth: true
          }
        },
        {
          path: 'welcomeadmin',
          name: 'welcomeadmin',
          component: WelcomeAdmin,
          meta: {
             requiresAuth: true
          }
        },
        {
          path: 'privacyadmin',
          name: 'privacyadmin',
          component: PrivacyAdmin,
          meta: {
             requiresAuth: true
          }
        }
      ]   
    },
    {
      path: '/notauth',
      name: 'notauth',
      component: NotAuthorised,
      meta: {
         requiresAuth: true
      }     
    }
  ]
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const currentUser = firebase.auth().currentUser
  //console.log('Router: ' + currentUser.displayName)
  if (requiresAuth && !currentUser) {
     next('/login')
  } else if (requiresAuth && currentUser) {
    next()
  } else {
      next()
  }
})

export default router